export const openPromoOfferPopup = () => dispatch => {
  dispatch({ type: 'TOGGLE_OFFER_POPUP', data: true });
};

export const closePromoOfferPopup = () => dispatch => {
  dispatch({ type: 'TOGGLE_OFFER_POPUP', data: false });
};
